import { ObservabilityProvider } from "../provider";

export const datadogProvider: ObservabilityProvider = {
  event: (name, attributes) => {
    window.DD_RUM?.addAction(name, attributes);
  },
  identify: (userId, attributes) => {
    if (userId) {
      window.DD_RUM?.setUser({ id: userId, ...attributes });
    } else {
      window.DD_RUM?.setUser({ ...attributes });
    }
  },
  reset: () => {
    window.DD_RUM?.clearUser();
  },
};
